      <ng-date [(ng-model)]="input"  id="birthday"
               [(ng-error)]="error_birthDay"
               [months]="items.monthList"
                title-year='setup_1.year-field-title'
                (update)="birthdayUpdatedEvent()">

            <h2 translate='setup_1.whenChildBorn' id="whenChildBorn"></h2>
            
      </ng-date> 
   
      <div aria-live='assertive'>
      <notice-box [hidden]="!eligibility.isOneYearMore">
            <div>
                  <span html='setup_1.over-a-year-critical-notice2-text1'></span>
                  <span html='setup_1.over-a-year-critical-notice2-text11' [hidden]="nextRegis=='N'"></span>
                  <span html='setup_1.over-a-year-critical-notice2-text12'></span>
                  <a  routerLink='/ORG_contact_information' 
                        alt-text='setup_1.over-a-year-critical-notice2-alt1'
                       translate='setup_1.over-a-year-critical-notice2-label1'></a>.
            </div>
            <div class="padding-top-1em">
                  <span       html='setup_1.over-a-year-critical-notice2-text2'></span>
                  <a-link link-url='setup_1.over-a-year-critical-notice2-link2' 
                          alt-text='setup_1.over-a-year-critical-notice2-alt2' 
                             label='setup_1.over-a-year-critical-notice2-label2'></a-link>.
            </div>
      </notice-box>
      </div>
